import { Sport, SportOrShared } from '#src/__generated__/globalTypes.ts';
import { FootballLogo } from '#src/atoms/icons/FootballLogo.tsx';
import { MLBLogo } from '#src/atoms/icons/MLBLogo.tsx';
import { NBALogo } from '#src/atoms/icons/NBALogo.tsx';
import { useIntlContext } from '#src/contexts/intl/index.ts';

import { glossary } from './glossary.ts';

const formattedSports: Record<Sport, string> = {
  [Sport.FOOTBALL]: 'Football',
  [Sport.NBA]: 'NBA',
  [Sport.BASEBALL]: 'MLB',
};

const sportToSportOrShared: Record<Sport, SportOrShared> = {
  [Sport.FOOTBALL]: SportOrShared.FOOTBALL,
  [Sport.NBA]: SportOrShared.NBA,
  [Sport.BASEBALL]: SportOrShared.BASEBALL,
};

const sportOrSharedToSport: Record<SportOrShared, Sport | null> = {
  [SportOrShared.FOOTBALL]: Sport.FOOTBALL,
  [SportOrShared.NBA]: Sport.NBA,
  [SportOrShared.BASEBALL]: Sport.BASEBALL,
  [SportOrShared.GLOBAL]: null,
};

export const getSportFromSportOrShared = (
  sportOrShared: SportOrShared | null | undefined
) => {
  if (!sportOrShared) return null;
  return sportOrSharedToSport[sportOrShared];
};

export const getSportOrSharedFromSport = (sport: Sport | null | undefined) => {
  if (!sport) return null;
  return sportToSportOrShared[sport];
};

export const getFormattedSport = (sport: Sport) => formattedSports[sport];

export const useFormattedSport = () => {
  const { formatMessage } = useIntlContext();
  return (sport: Sport | null | undefined) => {
    if (sport && sport in Sport) {
      return getFormattedSport(sport as unknown as Sport);
    }
    return formatMessage(glossary.global);
  };
};

export const sportIcons: Record<Sport, React.ComponentType> = {
  [Sport.FOOTBALL]: FootballLogo,
  [Sport.BASEBALL]: MLBLogo,
  [Sport.NBA]: NBALogo,
};
